import { render, staticRenderFns } from "./ChatAgentSide.vue?vue&type=template&id=d50525fc"
import script from "./ChatAgentSide.vue?vue&type=script&lang=js"
export * from "./ChatAgentSide.vue?vue&type=script&lang=js"
import style0 from "./ChatAgentSide.vue?vue&type=style&index=0&id=d50525fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports